import {management} from '../../../../index'

import {ShowFarmsByIdFarmUseCase} from '../showFarmsDapByIdFarm/showFarmsByIdFarmUseCase'
import {FarmsDapRepository} from '../../../infra/knex/repositories/farmsDapRepository'

export const showFarmsDapByIdFarmUseCase=new ShowFarmsByIdFarmUseCase(new FarmsDapRepository(management))
